"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MirrorAbilityHandler = exports.MirrorActorAbilityFactory = exports.MirrorAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Mirror_1 = require("../../core/effects/core/Mirror");
const Registries_1 = require("../../core/state/Registries");
const Enumerable_1 = require("../../utils/Enumerable");
class MirrorAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Mirror;
        this.__typeName = "Mirror";
    }
}
exports.MirrorAbilityArgs = MirrorAbilityArgs;
let MirrorActorAbilityFactory = class MirrorActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Mirror", "Self", 2);
    }
};
MirrorActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Mirror")
], MirrorActorAbilityFactory);
exports.MirrorActorAbilityFactory = MirrorActorAbilityFactory;
let MirrorAbilityHandler = class MirrorAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        const cloneArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.TempestMirror, invoker.level, Object.keys(invoker.attributeValues)
            .map(key => +key)
            .reduce((all, next) => {
            all[next] = 1 * invoker.attributeValues[next];
            return all;
        }, {}), {})
            .withAi("NoOp", {})
            .withPlayerId(invoker.playerId);
        const mirrorCountModifier = container.hasAttribute(ability.invokerId, "Charm_Tempest_0") ? 1
            : 0;
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_1.LinkedEffectsEffectArgs(Enumerable_1.Enumerable.rangeTo(2 + mirrorCountModifier).map(() => new Mirror_1.MirrorEffectArgs(cloneArgs)), false)
                });
            }
        });
    }
};
MirrorAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Mirror)
], MirrorAbilityHandler);
exports.MirrorAbilityHandler = MirrorAbilityHandler;
